import { defineEncodeDataAttribute, } from '@sanity/core-loader/encode-data-attribute';
/** @public */
export function useEncodeDataAttribute(result, sourceMap, studioUrl) {
    return defineEncodeDataAttribute(result, sourceMap, studioUrl);
}
